/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class CommentRepo {

    static $resource = 'comments';
    
    constructor($auth){
        $http = new Http($auth);        
    }

    show(id){
        return $http.get(CommentRepo.$resource + "/" + id + "?include=user.profile,sentences").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return $http.post(CommentRepo.$resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(){
        return $http.get(CommentRepo.$resource + "?include=user.profile,sentences").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(page, q, orderBy){
        let query = "page=" + page + "&include=user.profile,sentences";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(CommentRepo.$resource + "/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data){
        return $http.put(CommentRepo.$resource + "/" + id, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    delete(id){
        return $http.delete(CommentRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/repos/CommentRepo.js